export default __webpack_public_path__ + "static/media/centroMoons-mobile@1x.7fe22b22.webp";